<script lang="ts">
import { defineComponent } from 'vue';
import { formatDate } from '@/utils/format';

export default defineComponent({
  name: 'FootballMatchSummary',
  computed: {
    data() {
      return this.update.Data;
    },
    teams() {
      return this.fixture.Name.split(' v ');
    },
  },
  methods: {
    formatDate,
  },
  props: ['update', 'fixture'],
});
</script>

<template>
  <section v-if="update">
    <div
      :class="{
        'grid grid-flow-col grid-rows-[max-content_1fr_1fr] w-max': true,
        '[grid-template-columns:repeat(auto-fit,max-content)]': true,
        'text-center border-gray-500': true,
        'custom-cells m-auto my-2 border': true,
      }"
    >
      <div class="h">Начало</div>
      <div class="text-lg">{{ data?.StartTimes?.FirstHalf ? formatDate(data.StartTimes.FirstHalf, 'HH:mm:ss') : '-' }}</div>
      <div class="text-lg">{{ data?.StartTimes?.SecondHalf ? formatDate(data.StartTimes.SecondHalf, 'HH:mm:ss') : '-' }}</div>

      <div class="h">Фаза</div>
      <div class="text-lg row-span-2">{{ data.CurrentPhase }}</div>

      <div class="h">С начала фазы</div>
      <div class="font-mono text-lg row-span-2">{{ data.Clock.TimeElapsedInPhase }}</div>

      <div class="h">Часы идут</div>
      <div class="row-span-2">
        <i class="pi pi-check text-green-500 text-lg" v-if="data.Clock.IsClockRunning" />
        <i class="pi pi-times text-red-500 text-lg" v-else />
      </div>

      <div class="h">Команды</div>
      <div class="text-left">{{ teams[0] }}</div>
      <div class="text-left">{{ teams[1] }}</div>

      <div class="r h">Фолы</div>
      <div class="r font-mono text-lg">{{ data.Fouls.Score.Home }}</div>
      <div class="r font-mono text-lg">{{ data.Fouls.Score.Away }}</div>

      <div class="r h">Угловые</div>
      <div class="r font-mono text-lg">{{ data.Corners.Score.Home }}</div>
      <div class="r font-mono text-lg">{{ data.Corners.Score.Away }}</div>

      <div class="r h">Голевые</div>
      <div class="r font-mono text-lg">{{ data.GoalKicks.Score.Home }}</div>
      <div class="r font-mono text-lg">{{ data.GoalKicks.Score.Away }}</div>

      <div class="r h !bg-yellow-500"></div>
      <div class="r font-mono text-lg">{{ data.YellowCards.Score.Home }}</div>
      <div class="r font-mono text-lg">{{ data.YellowCards.Score.Away }}</div>

      <div class="r h !bg-red-500"></div>
      <div class="r font-mono text-lg">{{ data.StraightRedCards.Score.Home }}</div>
      <div class="r font-mono text-lg">{{ data.StraightRedCards.Score.Away }}</div>

      <div class="r h">Счет</div>
      <div class="r font-mono text-lg">{{ data.Goals.Score.Home }}</div>
      <div class="r font-mono text-lg">{{ data.Goals.Score.Away }}</div>

    </div>
  </section>
</template>

<style lang="scss" scoped>
.custom-cells {
  & > div {
    @apply px-3 py-2 text-lg;
    @apply border border-gray-500;

    &:not(.r) {
      @apply border-r-0;
    }

    &.h {
      @apply bg-gray-300 dark:bg-gray-700 place-content-center;
    }
  }
}

.row-span-2 { @apply place-content-center }
</style>
